module.exports = __webpack_public_path__ + "static/download_mac-b36bcf724bc71f295292ea1fbf066aa1.svg";